(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  class NodeRects {
    /**
     * Initializes a new instance of the class.
     * Sets the `node` property to null.
     */
    constructor() {
      this.node = null;
    }

    /**
     * Sets the node property to the provided node and returns the current instance for chaining.
     *
     * @param {HTMLElement} node - The DOM node to set.
     * @returns {this} The current instance for method chaining.
     */
    setNode(node) {
      this.node = node;
      return this;
    }

    /**
     * Measures the position and size of the DOM node associated with this instance.
     * Returns a Promise that resolves to an object containing the node's top, right, bottom, left, width, and height.
     * The measurement is performed in the next animation frame for accuracy.
     *
     * @returns {Promise<{top: number, right: number, bottom: number, left: number, width: number, height: number}>}
     *   A promise that resolves to an object with the node's bounding rectangle properties.
     */
    measure() {
      return new Promise((resolve) => {
        requestAnimationFrame(() => {
          const {
            offsetTop, offsetLeft, offsetWidth, offsetHeight
          } = this.node;
          const offset = {
            top: offsetTop,
            right: offsetLeft + offsetWidth,
            bottom: offsetTop + offsetHeight,
            left: offsetLeft,
            width: offsetWidth,
            height: offsetHeight
          };
          resolve(offset);
        });
      });
    }
  }

  global.NewHomeSource.Carousel.NodeRects = NodeRects;
}(window));
